// extracted by mini-css-extract-plugin
export var container = "styles-module__container___TQt4R";
export var searchResult = "styles-module__searchResult___KAdIK";